import Facebook from './channels/Facebook';
import Website from './channels/Website';
import Twitter from './channels/Twitter';
import Api from './channels/Api';
import Email from './channels/Email';
import Sms from './channels/Sms';
import Whatsapp from './channels/Whatsapp';
import WhatsappConnect from './channels/WhatsappConnect';
import Line from './channels/Line';
import Telegram from './channels/Telegram';
import IntertelUC from './channels/IntertelUC';
import StepTwo from './channels/evolutionApi/StepTwo.vue';
import StepThree from './channels/evolutionApi/StepThree.vue';
import StepFour from './channels/evolutionApi/StepFour.vue';

const channelViewList = {
  facebook: Facebook,
  website: Website,
  twitter: Twitter,
  api: Api,
  email: Email,
  sms: Sms,
  whatsapp: [Whatsapp, WhatsappConnect],
  line: Line,
  telegram: Telegram,
  interteluc: IntertelUC,
  evolution_api: [StepTwo, StepThree, StepFour],
  // Aqui se agregan los nuevos canales ...
};

export default {
  create() {
    return {
      props: {
        channel_name: {
          type: String,
          required: true,
        },
        step: {
          type: Number,
          default: 1,
        },
      },
      name: 'new-channel-view',
      render(h) {
        // Los canales con varios pasos se declaran como arreglo y la ruta indica el paso.
        const view = channelViewList[this.channel_name];
        const component = Array.isArray(view) ? view[this.step - 1] : view;
        return h(component || null);
      },
    };
  },
};
